import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -8","key":"svg-0"}],["path",{"d":"M4 10a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -8","key":"svg-1"}]]

const IconLayersIntersect = createReactComponent('outline', 'layers-intersect', 'LayersIntersect', __iconNode);

export default IconLayersIntersect;